import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../hooks";
import { requestRefreshTemplates } from "../slices/templates/templatesPanelSlice";

export function useTemplatesPanel() {
  const dispatch = useAppDispatch();
  const refreshTrigger = useAppSelector(
    (state) => state.TemplatesPanel?.refreshTrigger ?? 0,
  );

  const requestRefreshTemplatesAction = useCallback(
    () => dispatch(requestRefreshTemplates()),
    [dispatch],
  );

  return {
    refreshTrigger,
    requestRefreshTemplates: requestRefreshTemplatesAction,
  };
}
